import {
  PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_BEGIN,
  PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_SUCCESS,
  PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_FAILURE,
  PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';

export function createCollectionWithXano(args = {}) {
  console.log('createCollectionWithXano', args);
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}collections/createWithXano`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          console.log('collection stored done', res);
          resolve(res);
        },

        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_FAILURE,
            data: { error: errMsg },
          });
          console.log('createWithXano errrr', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithXanoError() {
  return {
    type: PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_BEGIN:
      return {
        ...state,
        createCollectionWithXanoPending: true,
        createCollectionWithXanoError: null,
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_SUCCESS:
      return {
        ...state,
        createCollectionWithXanoPending: false,
        createCollectionWithXanoError: null,
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_FAILURE:
      return {
        ...state,
        createCollectionWithXanoPending: false,
        createCollectionWithXanoError: action.data.error,
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithXanoError: null,
      };

    default:
      return state;
  }
}
